import {Injectable} from '@angular/core';

import {Subject} from 'rxjs';
import {TriggerEvent} from '../../../afb-api/models/trigger-event';
import {Airnote} from '../../../afb-api/models/airnote';

@Injectable()
export class DashboardService {
  private graphPinned = new Subject<Airnote | TriggerEvent>();
  graphPinned$ = this.graphPinned.asObservable();
  private deviceGridBackdrop = new Subject<{ isShow: boolean, backgroundColor?: string, opacity?: number, zIndex?: number }>();
  deviceGridBackdrop$ = this.deviceGridBackdrop.asObservable();
  private deviceGridTransparentBackdrop = new Subject<{ isShow: boolean, zIndex?: number }>();
  deviceGridTransparentBackdrop$ = this.deviceGridTransparentBackdrop.asObservable();
  private timelineBackdrop = new Subject<{ isShow: boolean, backgroundColor?: string, opacity?: number, zIndex?: number }>();
  timelineBackdrop$ = this.timelineBackdrop.asObservable();

  constructor() {
  }

  pinGraph(noti: Airnote | TriggerEvent): void {
    this.graphPinned.next(noti);
  }

  unpinGraph(): void {
    this.graphPinned.next(null);
  }

  backdropDeviceGrid(isShow: boolean, backgroundColor?: string, opacity?: number, zIndex?: number): void {
    this.deviceGridBackdrop.next({'isShow': isShow, 'backgroundColor': backgroundColor, 'opacity': opacity, 'zIndex': zIndex});
  }

  transparentBackdropDeviceGrid(isShow: boolean, zIndex?: number): void {
    this.deviceGridTransparentBackdrop.next({'isShow': isShow, 'zIndex': zIndex});
  }

  backdropTimeline(isShow: boolean, backgroundColor?: string, opacity?: number, zIndex?: number): void {
    this.timelineBackdrop.next({'isShow': isShow, 'backgroundColor': backgroundColor, 'opacity': opacity, 'zIndex': zIndex});
  }
}
